import React, { useEffect, useState } from "react";
import InquiryModal from "./InquiryModal.jsx";

// Get form data from localStorage and check expiry
const getValidFormData = () => {
  const stored = JSON.parse(localStorage.getItem("commonEnquiryData"));
  if (!stored || Date.now() > stored.expiresAt) return null;
  return stored.data;
};

// Get midnight timestamp for expiry
const getTodayMidnight = () => {
  const now = new Date();
  now.setHours(24, 0, 0, 0);
  return now.getTime();
};

// Save form with expiry to localStorage
const saveFormToLocalStorage = (formData) => {
  const expiry = getTodayMidnight();
  const data = { data: formData, expiresAt: expiry };
  localStorage.setItem("commonEnquiryData", JSON.stringify(data));
};

const InquiryFormPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    // Prevent if modal was dismissed in this session
    const isDismissed = sessionStorage.getItem("enquiryModalDismissed");
    if (isDismissed === "true") return;

    const form = getValidFormData();
    if (form) return;

    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 25000);

    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = (payload) => {
    saveFormToLocalStorage(payload);
    setIsOpen(false);
    alert("Inquiry is submitted.");
  };

  const handleToggle = () => {
    setIsOpen(false);
    sessionStorage.setItem("enquiryModalDismissed", "true");
  };

  return (
    <InquiryModal
      isOpen={isOpen}
      toggle={handleToggle}
      onSubmit={handleSubmit}
    />
  );
};

export default InquiryFormPopup;
